import { SignalWatcher } from "@lit-labs/signals";
import { consume } from "@lit/context";
import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import { type EnabledFeatures, enabledFeatures } from "../../contexts/features-context";
import { appColorScheme, COLOR_SCHEME_STORAGE_KEY } from "../../contexts/theme-context";
import { IS_DEV } from "../../env";
import "./scheme-select";
import type { ColorSchemeChangeEvent } from "./scheme-select";

@customElement("ptc-color-scheme-signal-watcher")
export class ColorSchemeSignalWatcher extends SignalWatcher(LitElement) {
    @consume({ context: enabledFeatures, subscribe: true })
    features: EnabledFeatures;

    #onChange(ev: ColorSchemeChangeEvent) {
        appColorScheme.set(ev.detail);

        localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, appColorScheme.get());
        document.documentElement.setAttribute("data-color-scheme", appColorScheme.get());
    }

    connectedCallback() {
        super.connectedCallback();
        document.documentElement.setAttribute("data-color-scheme", appColorScheme.get());
    }

    render() {
        return html`
            <ptc-color-scheme-select
                @color-change=${this.#onChange}
                value=${appColorScheme.get()}
                ?experimental=${IS_DEV}
            >
                <slot></slot>
            </ptc-color-scheme-select>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ptc-color-scheme-signal-watcher": ColorSchemeSignalWatcher;
    }
}
